// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/IntegrationRun.yaml
// Generated: 2026-03-17T14:51:32.497Z
// </auto-generated>

import { ReadOnlyEntityService } from '@/lib/EntityService';
import { IntegrationRun } from '@/types/integration/IntegrationRun';

/**
 * IntegrationRun Service (Read-Only)
 * Query operations for IntegrationRun via the ABP API.
 */
export const integrationRunService = new ReadOnlyEntityService<IntegrationRun>(
  '/api/integration/integrationrun',
  'IntegrationRun',
);
